import React from "react";

const Button = (props) => {
  return (
    <button
      disabled={props.disabled}
      style={props.style}
      type={props.type}
      className={
        props.disabled
          ? "btn btn-disabled " + props.className
          : "btn btn-primary " + props.className
      }
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
};

export default Button;
